import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { HeartHandshakeIcon, UsersRoundIcon, HomeIcon } from 'lucide-react';
import { SectionHeading } from './shared/SectionHeading';
const ABOUT_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/bbc5cc94-35a7-4067-b168-1502ce17c04b.jpg';
const highlights = [{
  icon: HeartHandshakeIcon,
  label: 'Posvećena i topla njega'
}, {
  icon: UsersRoundIcon,
  label: 'Kvalifikovani njegovatelji'
}, {
  icon: HomeIcon,
  label: 'Podrška u vlastitom domu'
}];
export function About() {
  return <section id="o-nama" className="relative w-full bg-white py-20 lg:py-28" data-id="element-17">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-5 sm:px-8 lg:grid-cols-2 lg:gap-16" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        x: -40
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative" data-id="element-19">
          <div className="overflow-hidden rounded-[2rem] shadow-luxury ring-1 ring-black/5" data-id="element-20">
            <img src={ABOUT_IMG} alt="Njegovateljica drži ruku starije osobe" className="h-[420px] w-full object-cover lg:h-[520px]" loading="lazy" data-id="element-21" />
          </div>
          <div className="absolute -bottom-6 -right-4 rounded-2xl bg-gold-gradient px-7 py-5 text-white shadow-gold sm:-right-6" data-id="element-22">
            <span className="block font-display text-3xl font-bold" data-id="element-23">15+</span>
            <span className="text-sm text-white/85" data-id="element-24">
              godina iskustva u njezi
            </span>
          </div>
        </motion.div>

        <div data-id="element-25">
          <SectionHeading align="left" eyebrow="O nama" title="Dobro došli u Golden Care" subtitle="Golden Care pruža profesionalne usluge posredovanja između porodica kojima je potrebna njega i kvalifikovanih njegovatelja i njegovateljica." data-id="element-26" />
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="mt-5 max-w-xl text-base leading-relaxed text-muted sm:text-lg" data-id="element-27">
            Naša misija je osigurati sigurnu, kvalitetnu i pouzdanu podršku
            starijim i nemoćnim osobama — uz puno poštovanja, dostojanstva i
            topline u svakom trenutku.
          </motion.p>

          <div className="mt-8 space-y-3" data-id="element-28">
            {highlights.map((h, i) => <motion.div key={h.label} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1 * i
          }} className="flex items-center gap-4 rounded-2xl border border-cream bg-cream/60 px-5 py-4" data-id="element-29">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white text-gold shadow-sm ring-1 ring-gold/20" data-id="element-30">
                  <h.icon className="h-5 w-5" data-id="element-31" />
                </span>
                <span className="font-medium text-ink" data-id="element-32">{h.label}</span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}